module.exports = __webpack_public_path__ + "assets/img/amiya-nm-dark.1efef736.gif";